import { object, string, array } from "yup";

export const customerInsertUpdateSchema = object({
  customerCode: string()
    .required("Cari Hesap Kodu zorunludur")
    .max(50, "Cari Hesap Kodu 50 karakterden uzun olamaz"),
  customerName: string()
    .required("Cari Hesap Ünvanı zorunludur")
    .max(150, "Cari Hesap Ünvanı 150 karakterden uzun olamaz"),
  phone: string()
    .required("Telefon numarası zorunludur")
    .test(
      "phone-format",
      "Lütfen telefon numarasını doğru formatta giriniz",
      function (value) {
        if (!value) return true;
        if (value.startsWith("0")) {
          return /^0\d{10}$/.test(value);
        }
        return true;
      }
    ),
  email: string()
    .max(100, "E-Posta adresi 100 karakterden uzun olamaz.")
    .required("Lütfen E-Posta adresini giriniz")
    .email("Lütfen E-Posta adresini doğru formatta giriniz"),
  tcCode: string()
    .max(11, "TCKN en fazla 11 haneli olabilir.")
    .min(11, "TCKN en az 11 haneli olabilir.")
    .nullable(),
  taxCode: string()
    .max(10, "VKN en fazla 10 haneli olabilir.")
    .min(10, "VKN en az 10 haneli olabilir.")
    .nullable(),
  taxOffice: string()
    .max(100, "Vergi Dairesi 100 karakterden uzun olamaz")
    .nullable(),
  customerUserList: array(),
  postalCode: string()
    .max(20, "Posta Kodu 20 karakterden uzun olamaz.")
    .nullable(),
  address: string()
    .max(200, "Adres 200 karakterden uzun olamaz.")
    .nullable(),
});